<template>
  <div class="wrapper">
    <div class="title">
      <h3>{{ XXdata[0].name }}</h3>
      <p>{{ XXdata[0].putime }}</p>
      <div class="line"></div>
    </div>
    <div class="content" v-html="XXdata[0].content"></div>
  </div>
</template>

<script>
import { onepublic } from "@/api/patient.js";
export default {
  data() {
    return {
      XXdata: [],
    };
  },
  watch: {
    //监听到路由（参数）改变
    $route(val, from) {
      // 拿到目标参数 val.query.id 去请求接口
      this.getOnepublic();
    },
  },
  mounted() {
    this.getOnepublic();
  },
  computed() {},
  methods: {
    getOnepublic() {
      let data = new FormData();
      data.append("id", this.$route.params.id);
      onepublic(data).then((res) => {
        this.XXdata = res;
      });
    },
  },
};
</script>
<style scoped>
.content {
  margin-left: 20px;
  font-size: medium;
  color: rgb(57, 57, 57);
}

>>> p {
  color: rgb(0, 0, 0);
  font-size: medium;
  font-weight: 500;
  line-height: 1.5rem;
}
</style>
<style lang="scss" scoped>
.wrapper {
  width: 40vw;
  border-radius: 5px;
  background-color: #fff;
  margin-left: 20px;
  margin-bottom: 30px;

  .title {
    margin-top: 20px;
    text-align: center;

    .line {
      height: 1px;
      background-color: #000;
      // width: 96%;
      margin: 0 auto;
    }
  }
}
</style>
